import * as React from "react";
import { forwardRef } from "react";
const CalendarIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.9712 8H1.99681V4.971c0-.536.4343-.971.96944-.971h1.02736v2h1.99681V4h7.98718v2h1.9968V4h.9984c.5512 0 .9984.448.9984 1zm0 9c0 .55-.4492 1-.9984 1H2.99521c-.55112 0-.9984-.448-.9984-1v-7H17.9712zm-17.9073022.761C.0638978 18.865 1.02137 20 2.1236 20H18.098C19.2013 20 20 18.979 20 17.761c0-.389-.0319-12.401-.0319-13.053 0-2.082-.2806-2.708-3.9937-2.708V0h-1.9968v2H5.99042V0H3.99361v2h-1.9968C.898562 2 0 2.9 0 4z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(CalendarIcon);
export { ForwardRef as CalendarIcon };